
<app-offline></app-offline>
<router-outlet></router-outlet>
<ngx-spinner
size = "medium"
type = "square-jelly-box">
<p style="color: white" > {{'LOADING' | translate}}... </p></ngx-spinner>
